import { create } from 'zustand';
import { fyOf } from '@/lib/financialOverview';

/** 'all' or a financial year like '2026-27'. */
export type OverviewYear = string;

interface FinancialOverviewState {
  fy: OverviewYear;
  /** A selected 'YYYY-MM', or null for the whole period. */
  month: string | null;
  setFy: (fy: OverviewYear) => void;
  setMonth: (month: string | null) => void;
}

// Kept in a store so the selection survives leaving the page and coming back,
// like every other filter in the app.
export const useFinancialOverviewStore = create<FinancialOverviewState>()((set) => ({
  fy: fyOf(new Date()),
  month: null,
  setFy: (fy) => set({ fy, month: null }),
  setMonth: (month) => set({ month }),
}));
